import type { SearchGeoItemsByLabelQuery, SearchGeoItemsInAreaQuery } from "~/features/recordGeoItems/gqls";
import type { Locale } from "~/i18n/resolveLocale";
import type { PinnedLocation } from "~/lib/map/types";
import { geoItemPlaceName } from "./geoItemLabel";
import { parseCoords } from "./parseCoords";

type SearchedGeoItem =
  | SearchGeoItemsInAreaQuery["cnutSearchGeoItems"]["items"][number]
  | SearchGeoItemsByLabelQuery["cnutSearchGeoItems"]["items"][number];

/** Map a location-search geo-item to a map `PinnedLocation` (label + coords). */
export function geoItemToLocation(geo: SearchedGeoItem, locale: Locale): PinnedLocation {
  return {
    isShow: true,
    geoItemId: geo.id,
    // An empty label is drawn as the dot alone; lists name the GeoItem through geoItemDisplayName.
    label: geoItemPlaceName(geo.i18nLabel, locale) ?? "",
    coords: parseCoords(geo.coords),
  };
}
